import type { DecoratedUnisonProject } from '@witmetrics/utils';
import { formatUserName } from '@witmetrics/utils/strings';
import { getProjectTypeLabel } from '@/utils/projects';

export const classes = {
  row: 'flex w-full cursor-pointer items-center gap-3 rounded-none border-b border-black/[0.06] bg-transparent px-[18px] py-2.5 shadow-none transition-colors hover:bg-black/[0.03] dark:border-white/[0.08] dark:hover:bg-white/[0.04]',
  cardRow:
    'flex w-full cursor-pointer items-center gap-[13px] mb-[11px] rounded-2xl border border-black/10 bg-white/[0.82] px-4 py-[13px] shadow-aurora-card transition hover:border-brand-accent/55 hover:shadow-row-hover dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  activeRow: 'cursor-default hover:bg-transparent dark:hover:bg-transparent',
  flatRow: 'border-b-0',
  closeButton: 'ml-1 shrink-0',
  closeIcon: 'text-taupe-1 dark:text-mauve-3',
  avatar: 'size-10 rounded-xl',
  avatarIcon: 'size-8 shrink-0',
  rowContent: 'flex min-w-0 flex-1 flex-col gap-0.5',
  rowTitle:
    'truncate text-[13.5px] font-semibold leading-tight text-taupe-3 dark:text-mauve-1',
  rowSecondLine: 'flex min-w-0 items-center gap-1.5',
  type: 'truncate text-xs text-taupe-2 dark:text-mauve-2',
  code: 'shrink-0 rounded-md bg-black/[0.05] px-1.5 py-px font-mono text-[10px] text-taupe-2 dark:bg-white/[0.07] dark:text-mauve-2',
  rowChip: 'shrink-0',
  rowDate: 'shrink-0 text-right text-xs text-taupe-1 dark:text-mauve-3',
};

export function getTitle(project: DecoratedUnisonProject, showUser?: boolean) {
  if (showUser && project.user) return formatUserName(project.user);
  return getProjectTypeLabel(project.unisonProjectTypeId);
}
